export default __webpack_public_path__ + "static/media/campaign-1-ar.f2371b4d.svg";